export default __webpack_public_path__ + "static/media/DISS-CO_TOM_20241205.b3883b5e.pdf";